import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f9bf5da8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f9bf5da8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bf5da8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9bf5da8')) {
      api.createRecord('f9bf5da8', component.options)
    } else {
      api.reload('f9bf5da8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f9bf5da8&scoped=true", function () {
      api.rerender('f9bf5da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/level/index.vue"
export default component.exports